import ajax from '../../../helpers/ajax'
import campaignActionSharedActions, { getNewActionPayload } from '../../../campaign-action-shared/store/actions'
import storeModule from '../../../daisy-chains/store/module'
import { trackEvent } from '@/analytics/track'

export default {
  ...campaignActionSharedActions,

  handleIfAlreadyTakenAction() {
    // This is not yet a feature for event attendees.
    // Always return false.
    return false
  },

  saveNewAction({state, commit, dispatch, getters}, { attendingStatus, friendlyCaptchaSolution, hcaptchaResponse, recaptchaToken, turnstileToken }) {
    state.retryingSubmit = false
    state.submittingCreateAction = true

    const data = getNewActionPayload(state, 'attendee', getters.suppressEmailOptInField, {friendlyCaptchaSolution, hcaptchaResponse, recaptchaToken, turnstileToken})
    data.attendee.attending_status = attendingStatus

    ajax.post({
      url: state.createActionUrl,
      data,
      successHandler: ({ attendee, baseDaisyChainsPath, event, sendForumMagicLinkPath, trackingData }) => {
        // Successful RSVP!
        trackEvent('Attendee Created', trackingData.parameters, trackingData.identity)

        // Update the state to show the correct information
        state.attendingStatus = attendee.attendingStatus
        state.attendingShiftIds = attendee.shiftIds
        state.updateAttendeeUrl = attendee.updatePath
        state.eventStatus.full = event.full

        // Reveal full address of event, if needed
        if (state.eventStatus.hiddenAddress) {
          state.fullLocationHtml = event.fullLocationHtml
          state.locationRevealed = true
        }

        if (event.webConferenceLink) {
          state.webConferenceLinkHtml = event.webConferenceLink
          state.webConferenceLinkRevealed = true
        }

        // Reveal discussion forum or "get a magic link" button
        document.dispatchEvent(new CustomEvent('agra:update-forum-context', {
          detail: {
            canViewForum: attendee.canViewForum,
            forumProps: attendee.forumProps,
            sendMagicLinkUrl: sendForumMagicLinkPath,
            showLoginPrompt: true
          }
        }))

        if (attendee.requiresEmailConfirmation) {
          state.awaitingEmailConfirmation = true
        } else {
          // Return initial daisy chain step info
          dispatch('startDaisyChain', baseDaisyChainsPath)
        }
      },
      errorHandler: ({ info }) => {
        state.validationErrors = info.errors

        if (info.retryBotProtection) {
          if (state.retryCount < 2) {
            state.retryCount += 1
            state.retryingSubmit = true
          }
        } else {
          state.retryCount = 0
        }

        if (info.cancelOneClick) {
          commit('cancelOneClick')
        }

        // The RSVP might have failed due to the event or some shifts becoming full.
        // Update the event state in case this is what happened.
        state.eventStatus.full = info.event.full
        state.event.shifts = info.event.shifts
      }
    }).then(() => {
      state.submittingCreateAction = false
    })
  },

  startDaisyChain({commit}, baseDaisyChainsPath) {
    this.registerModule('daisyChain', storeModule)
    commit('setShowDaisyChain', true)
    commit('daisyChain/initializeDaisyChain', {
      pageKind: 'event',
      baseUrl: baseDaisyChainsPath,
      previousStepKind: null,
      repeatedAction: null,
      successMessageKey: 'public.daisy_chains.events.rsvp_success',
      thanksMessageKey: 'public.daisy_chains.events.thanks_for_rsvp'
    })
  },

  trackSawOneClick({state}) {
    trackEvent('Saw event one-click attendee', {
      action: 'one-click-attendee',
      category: 'event',
      name: state.event.slug,
      event: state.event.slug
    })
  },

  updateAttendee({ state, commit }, { attendingStatus, shiftIds }) {
    const updateData = {}
    if (attendingStatus) {
      updateData.attending_status = attendingStatus
    }
    if (shiftIds) {
      updateData.shift_ids = shiftIds
    }

    ajax.patch({
      url: state.updateAttendeeUrl,
      data: {
        attendee: updateData
      },
      successHandler: ({ attendee, event }) => {
        state.attendingStatus = attendee.attendingStatus
        state.attendingShiftIds = attendee.shiftIds
        commit('doneEditingAttendingShifts')

        state.eventStatus.full = event.full
        state.event.shifts = event.shifts
      },
      errorHandler: ({ message, info }) => {
        // Updating the attendee failed. This can happen if the event or some shifts have become full,
        // so update the event state with the latest info.
        state.eventStatus.full = info.event.full
        state.event.shifts = info.event.shifts

        commit('setToastErrorMessage', message)
      }
    })
  }
}
